import React from 'react';
import {
  Typography, Table, TableBody, TableCell, Paper, TableRow,
} from '@mui/material';
import { _t } from 'utils';

export default ({
  properties, title = _t('Properties'), rowWidth = 'auto', margin = 10, className,
}) => (
  <>
    <Typography variant="h5" component="h2" style={{ margin: 10, marginTop: 20 }}>{title}</Typography>
    <Paper className={className} style={{ margin }}>
      <Table>
        <TableBody>
          {(properties || []).map(([prop, value, value2], i) => {
            const isValidValue = value !== undefined && value !== null;
            return (
              <TableRow key={i}>
                <TableCell
                  colSpan={!isValidValue ? 2 : 1}
                  style={{
                    fontWeight: '500',
                    width: rowWidth,
                  }}
                >
                  {prop}
                </TableCell>
                {
                  isValidValue && Object.prototype.hasOwnProperty.call(value, 'value')
                    ? (
                      <TableCell>
                        {`${value.prefix || ''}${value.value === undefined || Number.isNaN(value.value) ? '' : value.value}${value.suffix || ''}`}
                      </TableCell>
                    )
                    : (
                      isValidValue && <TableCell>{value}</TableCell>
                    )
                }
                {value2 && <TableCell>{value2}</TableCell>}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  </>
);
